export enum ExpiredSessionMessages {
  formDialogTitle = "expiredSession.formDialogTitle",
  formDialogContent = "expiredSession.formDialogContent",
  formDialogActionText = "expiredSession.formDialogActionText"
}

export interface TranslationExpiredSessionMessages {
  [ExpiredSessionMessages.formDialogTitle] : string;
  [ExpiredSessionMessages.formDialogContent] : string;
  [ExpiredSessionMessages.formDialogActionText] : string;
}
